<!-- src/views/Login.vue -->
<template>
  <div>
    <p>Logging you in...</p>
  </div>
</template>

<script>
import authService from '@/services/auth';

export default {
  name: 'LoginPage',
  mounted() {
    // Parse the authentication response
    authService.parseCognitoWebResponse(window.location.href);
  },
};
</script>
